module.exports = __webpack_public_path__ + "img/phones.13081cfa.png";